const autosize = require('autosize');

$(() => {
  if (!$('#admin-site_demos_edit').length && !$('#admin-site_demos_update').length) return;

  $(document).on('click', '.js-chat-gpt-demo-search', async function (e) {
    e.preventDefault();

    const $btn = $(this);
    const targetSelector = $btn.data('target');
    const siteId = $btn.data('site-id');
    const purpose = $btn.data('purpose');
    const nameFormat = $btn.data('name-format');
    const attributeFormat = $btn.data('attribute-format');
    const defaultValues = $btn.data('default-values') || {};

    const $textarea = $(targetSelector);
    const originalText = $btn.text();
    $btn.text('生成中...').prop('disabled', true);

    const results = [];

    const fetchData = async (format) => {
      return $.ajax({
        url: '/admin/chat_gpts',
        method: 'GET',
        dataType: 'json',
        data: { site_id: siteId, purpose: purpose, format: format }
      });
    };

    try {
      // nameFormat が有効なら実行
      if (typeof nameFormat === 'string' && nameFormat.trim() !== '') {
        const nameResponse = await fetchData(nameFormat);
        results.push(nameResponse);
      }

      // attributeFormat が有効なら実行
      if (typeof attributeFormat === 'string' && attributeFormat.trim() !== '') {
        const attributeResponse = await fetchData(attributeFormat);
        results.push(attributeResponse);
      }

      // マージ処理（defaultValues がオブジェクトならマージ）
      let merged = {};
      if (typeof defaultValues === 'object' && !Array.isArray(defaultValues)) {
        merged = structuredClone(defaultValues);
      }

      for (const res of results) {
        merged = Object.assign(merged, res);
      }

      // textarea にセット & autosize更新
      $textarea.val(JSON.stringify(merged, null, 2));
      autosize.update($textarea[0]);
    } catch (error) {
      console.error(error);
      alert("レスポンスが不正です");
    } finally {
      $btn.text(originalText).prop('disabled', false);
    }
  });
});
